module.exports = __webpack_public_path__ + "img/mdb.1bb8d601.svg";